import React from "react"
import styles from "./CardBlog.module.scss"
import { Link } from "gatsby"

import Grid from "@material-ui/core/Grid"

const CardBlog = ({
  title,
  to,
  description,
  excerpt,
  date,
  thumbnailImage,
  author,
  tags,
  onTagSelected,
  ...props
}) => {
  return (
    <Link
      style={{
        boxShadow: `none`,
        color: `inherit`,
      }}
      to={to}
    >
      <article className={styles.cardBlog} {...props}>
        <Grid container>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            className={styles.cardBlog_content}
          >
            <div style={{ padding: "0 var(--space-lg)" }}>
              <header>
                <h3>{title}</h3>
              </header>
              <section>
                <div className={styles.cardBlog_content_wrapper}>
                  <div>
                    <div className={styles.cardBlog_content_footer}>
                      {tags &&
                        tags.map(tag => (
                          <button
                            key={tag}
                            className={styles.cardBlog_tag}
                            onClick={() => onTagSelected(tag)}
                          >
                            #{tag}
                          </button>
                        ))}

                      <div className={styles.cardBlog_content_footer_space} />

                      <div
                        style={{
                          marginRight: "var(--space-md)",
                          color: "var(--grey-4)",
                        }}
                      >
                        <small>{date}</small>
                      </div>

                      {author && (
                        <div className={styles.cardBlog_author}>
                          <img src={author.profilePicture} alt={author.name} />

                          <p>{author.name}</p>
                        </div>
                      )}

                      {/* <Button
                        variant="text"
                        type="button"
                        style={{
                          textTransform: "lowercase",
                          fontFamily: "var(--heading-font-family)",
                          color: "var(--blue)",
                          fontSize: "var(--text-sm)",
                        }}
                        size="small"
                        endIcon={<ArrowRightAltRounded />}
                      >
                        Read more
                      </Button> */}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </Grid>
        </Grid>
      </article>
    </Link>
  )
}

export default CardBlog
